import { Button } from "@/components/ui/button";
import { VStack } from "@/components/ui/vstack";
import { Text } from "@/components/ui/text";
import { HStack } from "@/components/ui/hstack";
import { View } from "@/components/ui/view";
import React, { useState, useEffect, useLayoutEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { ScrollView } from 'react-native-gesture-handler';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import i18n from 'i18n-js';
import useIsMounted from '@/hooks/mounted'

import Footer from "@/components/basic/Footer";
import MediaCarousell from "@/components/media/MediaCarousell";
import ListElement from '@/components/workflow/ListElement';
import ItemText from '@/components/basic/ItemText';
import { switchScreen } from '@/hooks/navigate';
import BasicButton from "@/components/basic/BasicButton";
import { cancelPushNotification, schedulePushNotification, createTimeIntervalTrigger } from '@/containers/Notify';
import _ from 'lodash';
import { taskPause, taskSteps, taskDone, taskTimer } from "@/stores/mainSlice";
import * as Linking from 'expo-linking';

function Details({ navigation, toggleTimer, pauseTimer, pause, taskid, title, steps, idx, active, extra, restricted, isSimulator: isSimulator, isPreview: isPreview }) {
    const [timer, setTimer] = useState('')
    const [intTimer, setIntTimer] = useState(null)

    const mounted = useIsMounted()

    useEffect(() => {
        calcTimer(steps[idx])
    }, [idx])

    useEffect(() => {
        if (steps[idx].timerBeg && !steps[idx].timerPause) {
            if (!intTimer) {
                console.log('start timer refresh')
                calcTimer(steps[idx])
                setIntTimer(setInterval(calcTimer, 1000, steps[idx]))
            }
        } else {
            if (intTimer) {
                calcTimer(steps[idx])
                clearInterval(intTimer)
                setIntTimer(null)
            } else {
                calcTimer(steps[idx])
            }
        }
    }, [steps[idx].timerBeg, steps[idx].timerPause])

    useEffect(() => {
        return () => {
            if (!mounted()) {
                if (intTimer) {
                    console.log('stop timer refresh')
                    clearInterval(intTimer)
                    setIntTimer(null)
                }
            }
        };
    }, [mounted])

    const calcTimer = step => {
        if (step.timer > 0) {
            let time = step.timer
            if (step.timerBeg) {
                if (step.timerPause) {
                    time = step.timer - Math.round((step.timerPause - step.timerBeg) / 1000)
                } else {
                    time = step.timer - Math.round((Date.now() - step.timerBeg) / 1000)
                }
            }
            setTimer(Math.floor(time / 3600) + (Math.floor((time % 3600) / 60) < 10 ? ':0' : ':') + Math.floor((time % 3600) / 60) + (Math.floor((time % 3600) % 60) < 10 ? ':0' : ':') + Math.floor((time % 3600) % 60))
        } else {
            setTimer('00:00:00')
        }
    }

    switch (steps[idx].type) {
        case 1:
            return (steps[idx].check.map((item, i) =>
                <Button key={'C' + i} onPress={() => { switchScreen(navigation, 'ShowItem', { taskid: taskid, title: title, nextStep: idx == steps.length - 1 ? -1 : steps[idx].goto == undefined ? idx + 1 : steps[idx].goto, items: steps[idx].check, idx: i, active: active, restricted: restricted, isSimulator: isSimulator }) }} className="px-1 bg-secondary-50 h-[90px] active:bg-primary-300">
                    <ListElement key={'c' + idx + item.done + i} element={item} idx={i} updateItem={active ? updateItemState : null} />
                </Button>));
        case 2:
            return (
                <VStack space='xs' className="mt-2">
                    <View className="border rounded-sm border-primary-900 items-center">
                        <Text key={timer} bold className={` ${timer.startsWith('-') ? "text-ina.red" : "text-secondary-900"} text-5xl leading-5xl `}>{timer}</Text>
                    </View>
                    <HStack space='xs'>
                        {active && <BasicButton flex={1} isDisabled={steps[idx].timer == 0} onPress={() => toggleTimer(idx)} text={i18n.t(!steps[idx].timerBeg ? 'showStep.startTimer' : 'showStep.stopTimer')} />}
                        {active && <BasicButton flex={1} isDisabled={!steps[idx].timerBeg} onPress={() => pauseTimer(idx)} text={i18n.t(pause ? 'showStep.continueTimer' : 'showStep.pauseTimer')} />}
                    </HStack>
                </VStack>
            );
        case 3:
            return (
                <HStack space='xs' className="mt-4">
                    <Button
                        onPress={() => {
                            if (steps[idx].no == -2 || (steps[idx].no == -1 && idx == steps.length - 1)) {
                                if (active) {
                                    switchScreen(navigation, 'Finished', { taskid: taskid, title: title, isSimulator: isSimulator })
                                }
                            } else {
                                let tgt = steps[idx].no > -1 ? steps[idx].no : idx + 1
                                if (tgt < steps.length) {
                                    switchScreen(navigation, 'ShowStep', { taskid: taskid, idx: tgt, extra, isSimulator: isSimulator, isPreview: isPreview })
                                }
                            }
                        }}
                        className="bg-black w-[49.5%] active:opacity-50">
                        <Text className="text-lg text-secondary-50">{i18n.t('showStep.no')}</Text>
                    </Button>
                    <Button
                        onPress={() => {
                            if (steps[idx].yes == -2 || (steps[idx].yes == -1 && idx == steps.length - 1)) {
                                if (active) {
                                    switchScreen(navigation, 'Finished', { taskid: taskid, title: title, isSimulator: isSimulator })
                                }
                            } else {
                                let tgt = steps[idx].yes > -1 ? steps[idx].yes : idx + 1
                                if (tgt < steps.length) {
                                    switchScreen(navigation, 'ShowStep', { taskid: taskid, idx: tgt, extra, isSimulator: isSimulator, isPreview: isPreview })
                                }
                            }
                        }}
                        className="bg-primary-900 w-[49.5%] active:bg-primary-700">
                        <Text className="text-lg text-secondary-50">{i18n.t('showStep.yes')}</Text>
                    </Button>
                </HStack>
            );
    }
    return <></>
}

export let updateItemState

export default function ShowStep({ route, navigation }) {
    const { taskid, idx, extra, isSimulator, isPreview } = route.params
    const task = useSelector(state => state.workflows[taskid])
    const [steps, setSteps] = useState(task.steps)
    const [pause, setPause] = useState(steps[idx].timerPause !== undefined)
    const restricted = task.step > -1 && task?.settings?.strict
    const [notifyId, setNotifyId] = useState(null)

    const mounted = useIsMounted()
    const dispatch = useDispatch()
    const insets = useSafeAreaInsets();

    const actionStopTask = () => {
        dispatch(taskDone({ taskid: task.id, abort: true }))
    }

    const actions = [
        isSimulator && isPreview && idx == 0
            ? { icon: '' }
            : { icon: 'keyboard-arrow-up', text: idx == 0 ? 'footer.backTask' : 'footer.prevStep', component: idx == 0 ? 'BACK' : 'ShowStep', params: { taskid: taskid, idx: idx - 1, extra, isSimulator: isSimulator, isPreview: isPreview } },
        isSimulator 
            ? isPreview 
                ? { icon: 'keyboard-arrow-up', text: 'footer.backTask', component: 'ShowWorkflow2', params: { taskid: taskid, isSimulator: true } } 
                : { icon: 'refresh', text: 'footer.restart', component: 'ShowWorkflow2', params: { taskid: taskid, isSimulator: true }, exec: actionStopTask } 
            : { icon: 'home', text: 'footer.home', component: 'Home' },
        restricted && !steps[idx].type == 0 && !(steps[idx].type == 1 && steps[idx].check.every(item => item.done)) && !(steps[idx].type == 2 && (steps[idx].timer == 0 || steps[idx].timerFinished)) 
            ? { icon: '' } 
            : (idx == steps.length - 1 && steps[idx].goto == undefined) || steps[idx].goto == -2 
                ? { icon: task.step > -1 ? 'keyboard-arrow-down' : '', text: 'footer.forward', component: 'Finished', params: { taskid: taskid, title: task.title, isSimulator: isSimulator } } 
                : { icon: steps[idx].type == 3 ? '' : 'keyboard-arrow-down', text: 'footer.forward', component: 'ShowStep', params: { taskid: taskid, idx: steps[idx].goto == undefined ? idx + 1 : steps[idx].goto, extra, isSimulator: isSimulator, isPreview: isPreview } },
    ]

    updateItemState = (item, i) => {
        setSteps(prevSteps => {
            let draftSteps = _.cloneDeep(prevSteps)
            draftSteps[idx].check[i] = item
            return draftSteps
        })
    }

    const toggleTimer = async (idx) => {
        setPause(false)
        dispatch(taskTimer({
            taskid: taskid,
            stepIdx: idx,
            start: !steps[idx].timerBeg,
            done: false
        }))
        if (!steps[idx].timerBeg) { // !steps[idx].timerBeg = true => start
            await scheduleNoti(idx, steps[idx].timer)
        } else if(notifyId){ // stop timer. Needs to be checked, if the notification still exists, because on ios, if cancelNoti is called with null id, app crashes, android somehow not
            await cancelNoti()
        }
    }

    const pauseTimer = async (idx) => {
        setPause(!pause)
        dispatch(taskPause({
            taskid: taskid,
            stepIdx: idx,
            timerBeg: pause ? Math.round(Date.now() - steps[idx].timerPause + steps[idx].timerBeg) : steps[idx].timerBeg,
            timerPause: pause ? undefined : Date.now()
        }))
        if(notifyId){
            await cancelNoti()
        } else {
            const remainingSeconds = (steps[idx].timer * 1000 - (steps[idx].timerPause - steps[idx].timerBeg))/1000
            await scheduleNoti(idx, remainingSeconds)
        }

    }

    const scheduleNoti = async (idx, seconds) => {
        const notificationId = await schedulePushNotification(
            {
                title: i18n.t('notify.title'),
                body: i18n.t('notify.timer', { idx: (idx + 1), title: task.title }),
                data: {nav: { type: 'timer', idx: idx, taskid: taskid }},
                sound: "default"
            },
            createTimeIntervalTrigger(seconds)
        )
        setNotifyId(notificationId)
    }

    const cancelNoti = async () => {
        await cancelPushNotification(notifyId)
        setNotifyId(null)
    }

    useLayoutEffect(() => {
        navigation.setOptions({ title: i18n.t(extra && extra[idx] ? 'showStep.extra' : 'showStep.title') + ' ' + (idx + 1), info: steps[idx].title }) // + ': ' + stepTypeName(steps[idx].type)
    }, [idx])

    useEffect(() => {
        // changed steps
        //console.log("Steps changed")
        setSteps(task.steps)
    }, [task.steps])

    useEffect(() => {
        // change active step: task is started, active step is not running a timer and step is different from active step
        if (task.step > -1 && task.step != idx) {
            if (!steps[idx].timerBeg && (!restricted || task.step < idx)) {
                //console.log("Set active step: " + idx)
                dispatch(taskSteps({
                    taskid: taskid,
                    steps: steps,
                    step: idx
                }))
            } else {
                dispatch(taskSteps({
                    taskid: taskid,
                    steps: steps,
                    step: null
                }))
            }
        }
    }, [idx])

    useEffect(() => {
        return () => {
            if (!mounted()) {
                dispatch(taskSteps({
                    taskid: taskid,
                    steps: steps,
                    step: null
                }))
            }
        };
    }, [mounted])

    return (
        <View className="flex-1 bg-secondary-50">
            <ScrollView contentContainerStyle={{ paddingBottom: 70 + insets.bottom }} >
                {steps[idx].media.length > 0 && <MediaCarousell uris={steps[idx].media} overlays={steps[idx].overlays} />}
                <VStack className="mx-3 mt-3 bg-secondary-50">
                    <ItemText title={steps[idx].title} text={task.step > -1 && steps[idx].text == i18n.t('itemInput.text') ? '' : steps[idx].text} isSimulator={isSimulator}/>
                    <Details navigation={navigation} toggleTimer={toggleTimer} pauseTimer={pauseTimer} pause={pause} taskid={taskid} title={task.title} steps={steps} idx={idx} active={task.step > -1} extra={extra} restricted={restricted} isSimulator={isSimulator} isPreview={isPreview} />
                </VStack>
            </ScrollView>
            <Footer navigation={navigation} actions={actions} />
        </View>
    );
}
